// https://stackoverflow.com/questions/33625485/equivalent-of-jquery-active-for-pure-javascript
//
// window.ajax_active is consumed exclusively by Capybara feature specs via
// wait_for_ajax (features/framework/taf/pages/base_page.rb) to know when the
// app's own asynchronous work has settled before running assertions. The
// counter is intentionally restricted to same-origin requests — see
// frontend/common/utils/same-origin.js for the rationale and the matching
// filter applied on the fetch/axios paths.

import isSameOriginRequest from "./utils/same-origin";

/* eslint-disable */
window.ajax_active = 0;
(open => {
  return XMLHttpRequest.prototype.open = function(method, url, async, user, pass) {
    if (isSameOriginRequest(url)) {
      this.addEventListener("readystatechange", (function() {
        if (this.readyState === 1) {
          window.ajax_active += 1;
        } else if (this.readyState === 4){
          window.ajax_active -= 1;
        }
      }), false);
    }
    return open.call(this, method, url, async, user, pass);
  };
})(XMLHttpRequest.prototype.open);
/* eslint-enable */
